// extracted by mini-css-extract-plugin
module.exports = {"pane-complete":"pane-complete__eTtI8","complete-text":"complete-text__e4GPW","complete-button":"complete-button__31-yO"};